import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../modules/auth/contexts/AuthContext'
import { UserRole } from '../../types/api'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRoles?: UserRole[]
  fallbackPath?: string
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRoles, fallbackPath }) => {
  const { isAuthenticated, isLoading, user } = useAuth()
  const location = useLocation()

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Verificando autenticação...</p>
        </div>
      </div>
    )
  }

  // Se não estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Verificar permissões quando necessário
  if (requiredRoles && requiredRoles.length > 0) {
    const hasPermission = user?.role ? requiredRoles.includes(user.role) : false

    if (!hasPermission) {
      return <Navigate to={fallbackPath || '/'} replace />
    }
  }

  // Se estiver autenticado, renderizar o componente filho
  return <>{children}</>
}

export default ProtectedRoute

